import styled from 'styled-components';

export const Container = styled.div`
  align-items: end;
  display: flex;
  flex-direction: column;
  gap: 1.9rem;
  position: relative;
`;
